module.exports = __webpack_public_path__ + "fwm_h5/img/HuatongyuLogo.1a30833b.png";